import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {bmiValue, handleNill, labelStyles, renderReportfield, renderTableTD, renderTableTH} from '../../utils/templateUtils';
import './irregular_period_template_date.scss';

export default function IrregularPeriodTemplateNew(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [obstetricRows, setObstetricRows] = useState([{type: '', hospital: '', year: ''}]);

  const [investigationRows, setInvestigationRows] = useState([
    {investigation: 'CBC', result: ''},
    {investigation: 'TSH', result: ''},
    {investigation: 'FT4', result: ''},
    {investigation: 'prolactin', result: ''},
    {investigation: 'USG', result: ''}
  ]);

  const [showTables, setShowTables] = useState({
    obstetric: true,
    pastHO: true,
    test: true,
    investigation: true,
    medication: true
  });

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: '1',
      drug: 'T. Nortas CR',
      genericName: 'Norethisterone 10mg',
      freq: '1-0-1',
      withFood: 'AF',
      duration: '7 Days'
    },
    {
      sno: '2',
      drug: 'iron tablet ( Furnext / Globac XT / Ferronomic plus)',
      genericName: 'Ferrous Sulfate',
      freq: '1-0-1',
      withFood: 'AF',
      duration: '30 Days'
    },
    {
      sno: '3',
      drug: 'Thyroxine',
      genericName: 'Levothyroxine',
      freq: '1-0-0',
      withFood: 'ES',
      duration: 'As advised'
    }
  ]);

  const obstetricHeaders = [
    {key: 'type', label: 'Delivery Type', inputType: 'select', options: ['Vaginal', 'Cesarean']},
    {key: 'hospital', label: 'Hospital Name'},
    {key: 'year', label: 'Year'}
  ];

  const pastHOHeaders = [
    {key: 'condition', label: 'Condition', inputType: 'select', options: ['Diabetes', 'Hypertension', 'TB', 'Hypothyroid', 'Hyperthyroid', 'Nil', 'Others']},
    {key: 'duration', label: 'Duration'},
    {key: 'medications', label: 'Medications'}
  ];

  const investigationHeaders = [
    {key: 'investigation', label: 'Investigation'},
    {key: 'result', label: 'Result'}
  ];

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Drug'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'freq', label: 'Freq'},
    {key: 'withFood', label: 'With Food?'},
    {key: 'duration', label: 'Duration'}
  ];

  const handleChange = e => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    var text = e.target.value;

    if (e.target.name === 'patientId') {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || '').trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            if (e.target.name === 'patientId') {
              setFormData({
                ...formData,
                patientName: namePat,
                age: data?.age,
                gender: data?.gender,
                patientId: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId') {
          setFormData({
            ...formData,
            patientId: e.target.value
          });
        }
      }
    } else {
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const [pastHORows, setPastHORows] = useState([
    {
      condition: '',
      duration: '',
      medication: ''
    }
  ]);

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('irregularPeriodReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Irregular Periods'
            }
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='IrregularPeriodTemplate'>
      <div className='IrregularPeriodTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'space-between'}}>
            Irregular periods
            <span>
              Date <input type='date' className={`createTime ${show ? 'hide' : 'show'}`} name='date' onChange={e => handleChange(e, 'date')} />
              <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.date}</span>
            </span>
          </h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <div className='row'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel
                label='Irregular periods since :'
                name='irregularPeriodSince'
                value={formData.irregularPeriodSince}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='days/months'
                minWidth='220px'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <SelectField
                label='Weight gain'
                name='weightGain'
                value={formData.weightGain}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <SelectField
                label='Weight loss'
                name='weightLoss'
                value={formData.weightLoss}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <SelectField
                label='Acne / Hirsuitism'
                name='acneHirsuitism'
                value={formData.acneHirsuitism}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-8'>
              <SelectField
                label='Bleeding in between periods / after intercourse'
                name='bleedingBetweenPeriodsIntercourse'
                value={formData.bleedingBetweenPeriodsIntercourse}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Others :' name='others' value={formData.others} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          <h3 className='mt-3'>Menstrual History</h3>

          <div className='row'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel
                label='Last Menstrual Period :'
                name='lmp'
                value={formData.lmp}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='days/months'
                minWidth='220px'
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-8'>
              <SelectField
                label='Cycles'
                name='cycles'
                value={formData.cycles}
                options={[
                  {label: 'Regular', value: 'Regular'},
                  {label: 'Irregular', value: 'Irregular'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Frequency :' name='frequency' value={formData.frequency} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-8'>
              <SelectField
                label='Pain'
                name='painduringperiods'
                value={formData.painduringperiods}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-8'>
              <SelectField
                label='Withdrawal Rx'
                name='requiresWithdrawal'
                value={formData.requiresWithdrawal}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>

          <div className='row' style={{fontSize: '18px'}}>
            <div className='col'>
              <SelectField
                label='Marital Status'
                name='maritalStatus'
                value={formData.maritalStatus}
                options={[
                  {label: 'Married', value: 'Married'},
                  {label: 'Unmarried', value: 'Unmarried'},
                  {label: 'Divorced', value: 'Divorced'},
                  {label: 'Widowed', value: 'Widowed'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>

          <div className='row' style={{fontSize: '18px'}}>
            <div className='col'>
              <SelectField
                label='Sexually Active'
                name='sexuallyActive'
                value={formData.sexuallyActive}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>

          <div className='row' style={{fontSize: '18px'}}>
            <div className='col-md-4'>
              <SelectField
                label='Using Contraceptive'
                name='usingContraceptive'
                value={formData.usingContraceptive}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Method :' name='method' value={formData.method} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          <h3 className='mt-3'>Obstetric history</h3>

          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Gravida (G):' name='gravida' value={formData.gravida} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Para (P):' name='para' value={formData.para} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Abortions (A):' name='abortions' value={formData.abortions} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
            </div>
          </div>
          <div className='row my-2'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Living child :' name='livingChild' value={formData.livingChild} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          <div className='row' style={{fontSize: '18px'}}>
            <div className='col-md-4'>
              <SelectField
                label='Sterilized'
                name='sterilized'
                value={formData.sterilized}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Year of Sterilization :'
                name='yearOfSterilization'
                value={formData.yearOfSterilization}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                minWidth='180px'
              />
            </div>
          </div>
        </div>

        {showTables.pastHO && (
          <TemplateTable
            id='pastHO'
            title='Past H/O:'
            headers={pastHOHeaders}
            rows={pastHORows}
            onRowsChange={(id, newRows) => setPastHORows(newRows)}
            enableActions={true}
            onNill={() => handleNill('pastHO', setShowTables)}
          />
        )}
        <h3 className='mt-3'>On examination</h3>

        <div className='detail'>
          <div className='row my-2'>
            <div className='col-md-4'>
              <SelectField
                label='GC'
                name='gc'
                value={formData.gc}
                options={[
                  {label: 'Fair', value: 'Fair'},
                  {label: 'Good', value: 'Good'},
                  {label: 'Poor', value: 'Poor'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>

            <div className='col-md-4'>
              <SelectField
                label='Hydration'
                name='hydration'
                value={formData.hydration}
                options={[
                  {label: 'Adeq', value: 'Adeq'},
                  {label: 'Inadeq', value: 'Inadeq'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Height :' name='height' value={formData.height} onChange={handleChange} show={true} endLabel='cm' />
            </div>
          </div>

          <div className='row mt-2'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Weight :' name='weight' value={formData.weight} onChange={handleChange} show={true} endLabel='kg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='BMI :'
                name='maleBMI'
                value={bmiValue(formData.height, formData.weight)} // auto-calculated
                show={true}
                endLabel='kg/m2'
                disabled // make it non-editable
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='PR :' name='PR' value={formData.PR} onChange={handleChange} show={true} endLabel='bpm' />
            </div>
          </div>

          <div className='row mt-2'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Blood Pressure (BP) :' name='BP' value={formData.BP} onChange={handleChange} show={true} endLabel='mmHg' minWidth='200px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Per abdomen :' name='perabdomen' value={formData.perabdomen} onChange={handleChange} show={true} minWidth='130px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='PS :' name='ps' value={formData.ps} onChange={handleChange} show={true} minWidth='130px' />
            </div>
          </div>

          <div className='row pb-3' style={{fontSize: '18px'}}>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='PV :' name='pv' value={formData.pv} onChange={handleChange} show={true} minWidth='130px' />
            </div>
            <div className='col-md-4'>
              <SelectField
                label='Pap Smear/HPV'
                name='papsmearhpv'
                value={formData.papsmearhpv}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>

          {showTables.investigation && (
            <TemplateTable
              id='investigation'
              title='Investigations'
              headers={investigationHeaders}
              rows={investigationRows}
              onRowsChange={(id, newRows) => setInvestigationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('investigation', setShowTables)}
            />
          )}
        </div>

        {showTables.medication && (
          <TemplateTable
            id='medication'
            title='Medications'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medication', setShowTables)}
          />
        )}

        <div className='d-flex align-items-start py-2' style={{gap: '10px'}}>
          <label htmlFor='additionalInstructions' className='fw-bold' style={{whiteSpace: 'nowrap', paddingTop: '6px'}}>
            Additional Instructions:
          </label>
          <textarea className='Textarea' placeholder='add instructions' id='additionalInstructions' name='additionalInstructions' onChange={handleChange} rows='4' cols='100' />
        </div>

        <div className='bulletin'>
          <ul>
            <li>Take your medications fully as per course as stopping hormonal pills in between can lead to bleeding again</li>
          </ul>
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT APPOINTMENT - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='irregularPeriodReport'>
        <div id='irregularPeriodReportWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>Irregular Period</h4>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '10px'}}>
            {renderReportfield(' Irregular periods since :', formData.irregularPeriodSince)}
            days/months
            {renderReportfield(' Weight Gain :', formData.weightGain)}
            {renderReportfield(' Weight Loss :', formData.weightLoss)}
            {renderReportfield(' Acne / Hirsuitism:', formData.acneHirsuitism)}
            {renderReportfield(' Bleeding in between periods / after intercourse', formData.bleedingBetweenPeriodsIntercourse)}
            {renderReportfield('Others :', formData.others)}
          </div>

          <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '10px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>Menstrual History</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '10px'}}>
            {renderReportfield('Last Menstrual Period :', `${formData.lmp ? formData.lmp : ''} days/months`)}
            {renderReportfield('Cycles :', formData.cycles)}
            {renderReportfield('Frequency :', formData.frequency)}
            {renderReportfield('Pain :', formData.painduringperiods)}
            {renderReportfield('Withdrawal Rx :', formData.requiresWithdrawal)}
            {renderReportfield('Marital Status :', formData.maritalStatus)}
            {renderReportfield('Sexually Active :', formData.sexuallyActive)}
            {renderReportfield('Using Contraceptive :', formData.usingContraceptive)}
            {renderReportfield('Method :', formData.method)}
          </div>

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>Obstetric history</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '10px'}}>
            {renderReportfield('Gravida (G) :', formData.gravida, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Para :', formData.para, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Abortions (A) :', formData.abortions, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Living child :', formData.livingChild, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Sterilized :', formData.sterilized)}
            {renderReportfield('Year of Sterilization :', formData.yearOfSterilization)}
          </div>

          {showTables.pastHO && (
            <>
              {' '}
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h6 style={{fontWeight: 600, marginRight: '5px'}}>Past H/O</h6>
              </div>
              <table
                style={{
                  marginBottom: '10px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>{['Condition', 'Duration', 'Medication'].map((ele, ind) => renderTableTH(ele))}</tr>
                </thead>
                <tbody>
                  {pastHORows.map((ele, ind) => {
                    return (
                      <tr key={ind}>
                        {renderTableTD(ele.condition)}
                        {renderTableTD(ele.duration)}
                        {renderTableTD(ele.medication)}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
          <div style={{display: 'flex', marginTop: '10px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>On examination</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '10px', marginTop: '10px'}}>
            {renderReportfield('GC :', formData.gc)}
            {renderReportfield('GC :', formData.hydration)}
            {renderReportfield('Height :', `${formData.height ? formData.height : ''} cm`)}
            {renderReportfield('Weight :', `${formData.weight ? formData.weight : ''} kg`)}
            {renderReportfield('BMI :', `${bmiValue(formData.height, formData.weight)} kg/m2`)}
            {renderReportfield('PR :', formData.PR)}
            {renderReportfield('BP :', `${formData.BP ? formData.BP : ''} mm/hg`)}
            {renderReportfield('Per abdomen :', `${formData.perabdomen ? formData.perabdomen : ''} `)}
            {renderReportfield('PS :', formData.ps)}
            {renderReportfield('PV :', formData.pv)}
            {renderReportfield('Pap Smear/HPV :', formData.papsmearhpv)}
          </div>

          {showTables.investigation && (
            <>
              {' '}
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>Investigations :</h4>
              </div>
              <table
                style={{
                  marginBottom: '10px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>{investigationHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {investigationRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.investigation)}
                      {renderTableTD(row.result)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          {showTables.medication && (
            <>
              {' '}
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>Medications</h4>
              </div>
              <table
                style={{
                  marginBottom: '10px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>{medicationHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {medicationRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.sno)}
                      {renderTableTD(row.drug)}
                      {renderTableTD(row.genericName)}
                      {renderTableTD(row.freq)}
                      {renderTableTD(row.withFood)}
                      {renderTableTD(row.duration)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          <div style={{marginBottom: '5px'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>Additional Instructions:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.additionalInstructions}</pre>
          </div>
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '10px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <div style={{display: 'flex', marginBottom: '10px', marginTop: '10px'}}>
            <span>●</span>
            <p>Take your medications fully as per course as stopping hormonal pills in between can lead to bleeding again</p>
          </div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
